import { AUTOSPIN_VALUES } from '../../../../constants/autospin-values/autospin-values.constant'
import { InterfaceButton } from '../../button/interface.button.class'

/**
 * @file Defines the {@link AutospinInterfaceButton} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling autospin interface buttons
  * @extends InterfaceButton
  */
  export class AutospinInterfaceButton extends InterfaceButton {
      
    /**
     * Initialise content of autospin interface button
     * @param {autospin-interface-button} a_ - Object containing ID & content of button
     */
    constructor(a_) {
        super(a_) //Call parent constructor
    }

    /**
     * Click handler for autospin interface buttons
     */
    click() {
  
        autoPlayManager_.setAutoPlayValue(AUTOSPIN_VALUES.value()) //Set autoplay value in iron dog framework
        
        let text = document.getElementById('autospin-amount') //Retrieve autospin amount node
        let a    = AUTOSPIN_VALUES.value()                    //Store autospin amount
   
        text.innerHTML               = a //Update autospin in interface
        window.newUI.autospin().text = a //Update autospin button text
  
      }

  }